export default import.meta.ROLLDOWN_FILE_URL_uMhajtXY4E0NFYZE2c8qiw